module.exports = __webpack_public_path__ + "img/img.e777b486.jpg";